module.exports = __webpack_public_path__ + "static/img/no.c1d58db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/no.png
// module id = 5iK7
// module chunks = 1